import { useTypedSelector } from './useTypedSelector';

const useIsStoreScreen = () => {
  const isStoreScreen = useTypedSelector(
    (state) => state.navigation.storeScreen
  );
  return isStoreScreen;
};

export default useIsStoreScreen;
